import styled from "styled-components";
import { Input } from "antd";

interface StyledInputProps {
    placeholderFontSize?: string;
    height?: string;
    width?: string;
}

/**
 * Styled Ant Design Input that matches StyledSelect behavior.
 */
const StyledInput = styled(Input) <StyledInputProps>`
  width: ${({ width }) => width || "100%"};
  height: ${({ height }) => height || "3.563rem"};
  font-size: ${({ placeholderFontSize }) => placeholderFontSize || "1rem"};
  border-radius: 8px;
  padding: 0 12px;

  &::placeholder {
    font-size: ${({ placeholderFontSize }) => placeholderFontSize || "14px"};
    color: #bfbfbf;
  }

  &:focus {
    border-color: #1677ff !important;
    box-shadow: 0 0 0 2px rgba(22, 119, 255, 0.2);
  }

  /* Responsive styles matching StyledSelect */
  @media (max-width: 768px) {
    &::placeholder {
      font-size: 14px;
    }
    height: 45px !important;
    width: 100% !important;
    font-size: 14px;
  }

  @media (max-width: 550px) {
    &::placeholder {
      font-size: 10px;
    }
    height: 35px !important;
    width: 100% !important;
    font-size: 12px;
  }
`;

export default StyledInput;
